<div class="iad-page-404">
  <img src="assets/404.gif" alt="page 404" title="page 404" />
  <h1>{{ 'iadPage404.title' | translate }}</h1>
  <p>{{'iadPage404.catchPhrase' | translate }}</p>
  <button mat-raised-button color="primary" routerLink="/agent/home">{{ 'iadPage404.homeBtnLabel' | translate }}</button>
</div>
